import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import axios from 'axios'
import Cookies from 'js-cookie'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import ApiEndpoints, { BASE_URL, BASE_URL_Upload } from './commonComponents/ApiEndpoints'

const EditUser = ({ show, handleClose, user, onUserUpdated }) => {
  const [showPassword, setShowPassword] = useState(false)
  const [userImage, setUserImage] = useState(null)
  const [existingImageUrl, setExistingImageUrl] = useState('')
  const [updatedUser, setUpdatedUser] = useState({
    name: '',
    email: '',
    phone_number: '',
    password: '',
    user_type: '',
    designation: '',
  })

  useEffect(() => {
    if (user) {
      setUpdatedUser({
        name: user.name || '',
        email: user.email || '',
        phone_number: user.phone_number || user.phone || '',
        password: '',
        user_type: user.user_type || '',
        designation: user.designation || '',
      })
      setExistingImageUrl(user.profile_img_url || user.image || '')
      setUserImage(null)
    }
  }, [user])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdatedUser((prev) => ({ ...prev, [name]: value }))
  }

  const handleCloseModal = () => {
    setShowPassword(false)
    setUserImage(null)
    handleClose()
  }

  const handleSaveChanges = async (e) => {
    e.preventDefault()

    try {
      if (!user?.id) {
        toast.error('Invalid user selected.')
        return
      }

      let imageUrl = existingImageUrl || null
      if (userImage) {
        if (userImage.size > 2 * 1024 * 1024) {
          toast.error('Image size should not exceed 2MB.')
          return
        }
        const instituteId = Number(Cookies.get('institute_id'))
        if (!instituteId) {
          toast.error('Institute is required for image upload.')
          return
        }
        const formData = new FormData()
        formData.append('image', userImage)
        formData.append('folder', 'user')
        const imageResponse = await axios.post(
          BASE_URL + '/upload-image',
          formData,
        )
        if (imageResponse.data && imageResponse.data.path) {
          imageUrl = BASE_URL_Upload + `/${imageResponse.data.path}`
        } else {
          throw new Error('Image upload failed.')
        }
      }

      const payload = {
        name: updatedUser.name,
        email: updatedUser.email,
        phone_number: (updatedUser.phone_number || '').trim() || null,
        institute_id: Number(Cookies.get('institute_id')),
        user_type: updatedUser.user_type,
        designation: (updatedUser.designation || '').trim() || null,
        profile_img_url: imageUrl,
      }

      if (updatedUser.password.trim()) {
        payload.password = updatedUser.password.trim()
      }

      let token = Cookies.get('token') || ''
      if (!token) {
        try {
          token = JSON.parse(Cookies.get('user') || '{}')?.token || ''
        } catch (parseErr) {
          token = ''
        }
      }

      const response = await axios.put(`${BASE_URL}/users/${user.id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      toast.success(response.data?.message || response.data?.result || 'User updated successfully')
      handleCloseModal()
      if (typeof onUserUpdated === 'function') {
        await onUserUpdated()
      }
    } catch (error) {
      if (error.response?.data?.errors) {
        Object.values(error.response.data.errors).forEach((errArr) => {
          errArr.forEach((msg) => toast.error(msg))
        })
      } else {
        toast.error(
          error.response?.data?.message ||
            error.response?.data?.result ||
            'Failed to update user.',
        )
      }
    }
  }

  return (
    <Modal show={show} onHide={handleCloseModal} centered size="lg">
      <Modal.Header closeButton
        closeVariant="white"
        className="text-white bg-warning"
        // style={{ backgroundColor: '#223843' }}
      >
        <Modal.Title>Edit User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSaveChanges}>
          <Form.Group className="mb-3">
            <Form.Label>Name *</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={updatedUser.name}
              onChange={handleInputChange}
              placeholder="Enter User's Name"
              className="p-2 border rounded"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email ID *</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={updatedUser.email}
              onChange={handleInputChange}
              placeholder="Enter Email"
              className="p-2 border rounded"
              disabled
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Phone number</Form.Label>
            <Form.Control
              type="tel"
              name="phone_number"
              value={updatedUser.phone_number}
              onChange={handleInputChange}
              placeholder="Enter phone number"
              className="p-2 border rounded"
              inputMode="tel"
              autoComplete="tel"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>User Type *</Form.Label>
            <Form.Select
              name="user_type"
              value={updatedUser.user_type}
              onChange={(e) => {
                const value = e.target.value
                setUpdatedUser((prev) => ({
                  ...prev,
                  user_type: value,
                }))
              }}
              required
            >
              <option value="">Select</option>
              <option value="admin">Admin</option>
              <option value="accountant">Accountant</option>
              <option value="staff">Staff</option>
              <option value="fees_collector">Fee Collector</option>
              <option value="marketer">Marketer</option>
              <option value="bus_attendant">Bus Attendant</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Designation</Form.Label>
            <Form.Control
              type="text"
              name="designation"
              value={updatedUser.designation}
              onChange={handleInputChange}
              placeholder="Enter designation"
              className="p-2 border rounded"
            />
          </Form.Group>

          {/* <Form.Group className="mb-3 mt-3">
            <Form.Label>Password</Form.Label>
            <div className="input-group">
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={updatedUser.password}
                onChange={handleInputChange}
                placeholder="Enter new password (optional)"
                className="p-2 border rounded"
              />
              <Button
                type="button"
                variant="outline-secondary"
                onClick={() => setShowPassword((prev) => !prev)}
                title={showPassword ? 'Hide Password' : 'Show Password'}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </Button>
            </div>
          </Form.Group> */}

          <Form.Group className="mb-3">
            <Form.Label>User Image (PNG/JPG/JPEG)</Form.Label>
            <div className="d-flex align-items-center gap-3 mt-2 mb-2">
              <Form.Control
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                onChange={(e) => setUserImage(e.target.files[0])}
                style={{ maxWidth: '700px' }}
              />
              {(userImage || existingImageUrl) && (
                <img
                  src={userImage ? URL.createObjectURL(userImage) : existingImageUrl}
                  alt="Preview"
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: 'cover',
                    borderRadius: 8,
                    border: '1px solid #ccc',
                  }}
                />
              )}
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleCloseModal}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditUser
